import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { createFeatureSelector, createReducer, createSelector, on } from '@ngrx/store';
import * as Actions from './actions'
import { IVoucher } from 'app/models/voucher';
import { addVoucherSuccess } from './actions';


export interface State extends EntityState<IVoucher> {
  selectedId: string;
  addingVoucher: boolean;
  addedVoucherSuccess: boolean;
  error: string;
}

export function sortByRedeemDate(a: IVoucher, b: IVoucher): number {
  return a.redeemDate && b.redeemDate
    ? a.redeemDate.getTime() - b.redeemDate.getTime()
    : 0;
}
export function selectId(a: IVoucher): string {
  return a.id ?? '';
}
export const adapter: EntityAdapter<IVoucher> = createEntityAdapter<IVoucher>({
  sortComparer: sortByRedeemDate,
  selectId: selectId
});

export const initialState: State = adapter.getInitialState({
  selectedId: '',
  addingVoucher: false,
  addedVoucherSuccess: false,
  error: ''
});

export const stateName = 'voucher';

export const reducer = createReducer<State>(
  initialState,
  on(Actions.clearAllItems, (state) => {
    return adapter.removeAll(state);
  }),

  on(Actions.addVoucher, (state, action): State => {
    return {
      ...state,
      addingVoucher: true,
    };
  }),
  on(Actions.addVoucherSuccess, (state, action): State => {
    return {
      ...state,
      addingVoucher: false,
      addedVoucherSuccess: true,
    };
  }),



  on(
    Actions.loadItemSuccess,
    (state, { item }) => {
      return adapter.setOne(item, state);
    }),
  on(Actions.loadItemsSuccess, (state, { items }) => {
    return adapter.setAll(items, state);
  }),
  on(
    Actions.loadItemFailure,
    Actions.loadItemsFailure,
    Actions.addVoucherFailure,
    (state, action) => {
      return {
        ...state,
        addingVoucher: false,
        error: action.error
      };
    }),

);


//export const getSelectedPlaatoId = (state: PlaatoState) => state.selectedPlaatoId;

// get the selectors
const {
  // selectIds,
  selectEntities,
  selectAll,
  // selectTotal,
} = adapter.getSelectors();

// Export selectAll for effect caching
export { selectAll };

export const getSelectedId = (state: State) => state.selectedId;
export const getAddingVoucher = (state: State) => state.addingVoucher;
export const getAddedVoucherSuccess = (state: State) => state.addedVoucherSuccess;

export const getState = createFeatureSelector<State>(stateName);
export const selectAllItems = createSelector(getState, selectAll);
export const selectAllEntities = createSelector(getState, selectEntities);
export const getCurrentId = createSelector(getState, getSelectedId);

export const selectAddingVoucher = createSelector(getState, getAddingVoucher);
export const selectAddedVoucherSuccess = createSelector(getState, getAddedVoucherSuccess);


export const getCurrentItem = createSelector(selectAllEntities, getCurrentId, (entities, id) => {
  if (!!id) return entities[id];
  return null;
});
export const getEntity = (id: string) => createSelector(selectAllEntities, entities => entities[id]);


